<template>
  <div class="row justify-between" :style="cssVars">
    <div style="width: 20%">
      <div class="row">
        <span
          v-if="leftStaticColumn"
          class="leftStaticColumn-title leftStaticColumnTextColor"
        >
          {{ leftStaticColumn.label.toUpperCase() }}
        </span>
      </div>
      <div class="row"></div>
    </div>
    <div style="width: 60%">
      <q-scroll-area
        :thumb-style="{
          background: '#162c479c',
          opacity: 1,
          width: '8px',
          height: '8px',
          borderRadius: '20px',
        }"
        style="width: 1000px"
      >
        <div class="row">
          <div v-for="(col, i) in normalColumns" :key="i" class="col-4">
            <span class="normalColumnHeader">
              {{ col.label }}
            </span>
          </div>
        </div>
        <div class="row">
          <q-virtual-scroll
            class="q-pa-none"
            :style="`height:${maxHeight}; width: 100%;`"
          >
          </q-virtual-scroll>
        </div>
      </q-scroll-area>

      <!-- <div class="row justify-between">
        <div style="width: 20%">
          <span class="normalColumnHeader"> January </span>
        </div>
        <div style="width: 20%">
          <span class="normalColumnHeader"> February </span>
        </div>
        <div style="width: 20%">
          <span class="normalColumnHeader"> March </span>
        </div>
      </div>
      <div class="row"></div> -->
    </div>
    <div style="width: 20%">
      <div class="row justify-center">
        <span
          v-if="rightStaticColumn"
          class="rightStaticColumn-title rightStaticColumnTextColor"
        >
          {{ rightStaticColumn.label }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      leftStaticColumn() {
        if (this.columns.length > 0) {
          let index = this.columns.findIndex((e) => e.sticky == "left");
          if (index > -1) {
            return this.columns[index];
          } else {
            return null;
          }
        }
      },
      rightStaticColumn() {
        if (this.columns.length > 0) {
          let index = this.columns.findIndex((e) => e.sticky == "right");
          if (index > -1) {
            return this.columns[index];
          } else {
            return null;
          }
        }
      },
      normalColumns() {
        return this.columns.filter((e) => e.sticky == null);
      },
      cssVars() {
        return {
          "--normalColumnHeader": this.normalColumnHeaderTextColor,
        };
      },
    },
    props: {
      leftStaticColumnColor: {
        type: String,
        default: "#162c4",
      },
      leftStaticColumnTextColor: {
        type: String,
        default: "#162c4",
      },
      rightStaticColumnColor: {
        type: String,
        default: "#162c4",
      },
      rightStaticColumnTextColor: {
        type: String,
        default: "#162c4",
      },
      normalColumnHeaderTextColor: {
        type: String,
        default: "#162c4",
      },
      columns: {
        type: Array,
        default: [],
      },
      data: {
        type: Array,
        default: [],
      },
      maxHeight: {
        type: String,
        default: "100vh",
      },
    },
    methods: {
      test(value) {},
    },
  };
</script>

<style lang="scss" scoped>
  .leftStaticColumn-title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
  }

  .rightStaticColumn-title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
  }

  .normalColumnHeader {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    color: var(--normalColumnHeader);
  }

  .thead-sticky {
    position: sticky;
    opacity: 1;
    z-index: 1;
  }
</style>
